import OrderCutoffTime from './orderCutoffTime.component'

export default OrderCutoffTime
